import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Card, FormGroup, Button } from 'reactstrap';
import Select from 'react-select';

import { getRole } from 'constants/localStorageManager';
import { USERS } from 'constants/Users';

const createSelectables = items => {
  return items.map(item => ({
    label: `${item.title} Account`,
    value: item,
  }));
};

const TrialOptions = ({ onTrialLengthSelected, trialLength }) => {
  return (
    <div>
      <div className="plan-label mt-4">Trial Length</div>
      <div className="trial-length">
        <label className="trial-radio">
          <input
            onClick={onTrialLengthSelected}
            className="radio-btn"
            type="radio"
            value={7}
            name="trialLength"
            defaultChecked
            checked={trialLength == 7}
          />{' '}
          7 days
        </label>
        <label className="trial-radio">
          <input
            onClick={onTrialLengthSelected}
            className="radio-btn"
            type="radio"
            value={14}
            name="trialLength"
            checked={trialLength == 14}
          />{' '}
          14 days
        </label>
        <label className="trial-radio">
          <input
            onClick={onTrialLengthSelected}
            className="radio-btn"
            type="radio"
            value={30}
            name="trialLength"
            checked={trialLength == 30}
          />{' '}
          30 days
        </label>
      </div>
    </div>
  );
};

TrialOptions.defaultProps = {
  onTrialLengthSelected: () => {},
  trialLength: 7,
};

TrialOptions.propTypes = {
  onTrialLengthSelected: PropTypes.func.isRequired,
  trialLength: PropTypes.number,
};

const DisplayPlan = ({ plan_subscription, toggleChangePlan }) => {
  return (
    <Fragment>
      <FormGroup>
        <h5> Account Settings </h5>
        <Card className="p-4 plan-container">
          <p className="plan-label">
            Current Plan:
            <span className="selected-plan-title">{plan_subscription.label}</span>
          </p>
          <Button
            className="col-sm-2 btn-change-plan"
            size="sm"
            onClick={() => toggleChangePlan(true)}
          >
            Change Plan
          </Button>
        </Card>
      </FormGroup>
    </Fragment>
  );
};

DisplayPlan.defaultProps = {
  plan_subscription: {
    label: '',
  },
};

DisplayPlan.propTypes = {
  plan_subscription: PropTypes.shape({
    label: PropTypes.string,
  }),
  toggleChangePlan: PropTypes.func.isRequired,
};

const SelectPlan = ({
  plans,
  handlePlanSelect,
  plan_subscription,
  onTrialLengthSelected,
  trialLength,
  isChangePlanVisible,
  toggleChangePlan,
}) => {
  const options = createSelectables(plans);
  const isTrialSelected =
    plan_subscription.value && plan_subscription.value.title == 'trial';
  if (getRole() !== USERS.ADMIN) return null;

  if (isChangePlanVisible)
    return (
      <Fragment>
        <FormGroup>
          <h5> Account Settings </h5>
          <Card className="p-4 plan-container">
            <span className="plan-label">Select an account type</span>
            <br />
            <Select
              name="state"
              className="text-capitalize"
              options={options}
              onChange={handlePlanSelect}
              value={plan_subscription}
              removeSelected
              clearable={false}
              required
            />
            {isTrialSelected && (
              <TrialOptions
                onTrialLengthSelected={onTrialLengthSelected}
                trialLength={trialLength}
              />
            )}
          </Card>
        </FormGroup>
      </Fragment>
    );

  return (
    <DisplayPlan
      plan_subscription={plan_subscription}
      toggleChangePlan={toggleChangePlan}
    />
  );
};

SelectPlan.defaultProps = {
  plans: [],
  plan_subscription: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.shape({
      title: PropTypes.string,
    }),
  }),
  trialLength: 7,
  isChangePlanVisible: false,
  toggleChangePlan: () => {},
};

Select.propTypes = {
  plans: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
    })
  ),
  handlePlanSelect: PropTypes.func.isRequired,
  plan_subscription: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.shape({
      title: PropTypes.string,
    }),
  }),
  onTrialLengthSelected: PropTypes.func.isRequired,
  trialLength: PropTypes.number,
  isChangePlanVisible: PropTypes.bool,
  toggleChangePlan: PropTypes.func,
};

export default SelectPlan;



// WEBPACK FOOTER //
// ./src/components/businesses/SelectPlan.js